import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, InputNumber } from "antd";
import InputForm from "./InputForm";
import UsuarioFrame from '../components/UsuarioFrame';
import "./Form.css";

const { Item: ItemForm } = Form;

export default class EmpresaoMetaForm extends Component {
  state = {
    registro: {
      em_idf: '',
      em_mes: new Date().getMonth() + 1,
      em_ano: new Date().getFullYear(),
      em_valor: 0,
    }
  };


  componentDidUpdate(propsAnterior, stateAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      this.setState({
        registro: this.props.registroSelecionado
      }, () => {
        // this.refs.registro.em_usuario.focus();
      });
    }
  }

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value
    });
  };

  onInputChangeMes = event => {
    const { registro } = this.state;
    registro['em_mes'] = event;
    this.setState(registro);
  }

  onInputChangeAno = event => {
    const { registro } = this.state;
    registro['em_ano'] = event;
    this.setState(registro);
  }


  onOK = () => {
    if (!this.state.registro.em_valor) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Valor da Meta' });
      return;
    }

    this.props.onSalvarClick(this.state.registro);
  };





  render() {
    const { onCancelarClick, carregando, visivel } = this.props;
    const { em_idf, em_mes, em_ano, em_valor } = this.state.registro;

    // console.log('EmpresaoMetaForm: ', this.state);

    return (
      <Modal
        title={em_idf ? "Edição de Meta Geral" : "Cadastro de Meta Geral"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"40%"}
        style={{ top: 30 }}
      >
        <Form>
          <Row>
            <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
              <Row>
                <span>Mês</span>
              </Row>
              <Row>
                <InputNumber
                  ref="Input"
                  id={em_mes}
                  value={em_mes}
                  onChange={this.onInputChangeMes}
                  min={1}
                  max={12}
                  maxLength={2}
                  disabled={em_idf ? true : false}
                  style={{ width: "100%" }}
                />
              </Row>
            </Col>
            <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
              <Row>
                <span>Ano</span>
              </Row>
              <Row>
                <InputNumber
                  ref="Input"
                  id={em_ano}
                  value={em_ano}
                  onChange={this.onInputChangeAno}
                  min={2020}
                  max={2100}
                  maxLength={4}
                  disabled={em_idf ? true : false}
                  style={{ width: "100%" }}
                />
              </Row>
            </Col>

            <Col xs={24} sm={12} style={{ marginTop: -25 }}>
              <span>Valor Meta</span>
              <InputForm
                type="number"
                id="em_valor"
                ref="em_valor"
                value={em_valor}
                onChange={this.onChange}
              />
            </Col>

          </Row>
          <ItemForm>
            <Row>
              <Col xs={24}>
                 <Button
                  htmlType="button"
                  loading={carregando}
                  onClick={this.onOK}
                  className="botoesModalForm"
                >
                  Salvar
                </Button>

                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="botoesModalFecharForm"
                >
                  Cancelar
                </Button>
              </Col>
            </Row>
          </ItemForm>

        </Form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EmpresaoMetaForm.js